<template>
  <div class="wrap-login justify-content-center">
      <div class="col-12 logo-register">
          <div class="center">
            <a href="/" title="Hành trang số">
               <img src="@/assets/images/logo_hts_1.png" alt="Hành trang số">
             </a>
          </div>
      </div>
      <div class="col-xl-3 col-lg-4 col-md-5 col-10 login-form">
          <div class="text-center col-12">
            <h2 class="text-left mb-5" style="font-size: 26px;">Quên mật khẩu</h2>
            <div class="text-left" style="font-size:13px; color:#879AA9;">Chúng tôi sẽ gửi quy trình đặt lại mật khẩu đến email của bạn.</div>
            <form action="" @submit.prevent="SubmitEmail">
                <div class="text-left form-group">
                  <label for="">Email</label><br>
                  <input 
                      type="email" 
                      id="email" 
                      class="form-control input-email" 
                      placeholder="Email của bạn"
                      v-model="email"
                      @blur="$v.email.$touch()"
                    >
                    <span class="error font-size-14 color-err display-block" v-if="$v.email.$dirty && !$v.email.required">Vui lòng điền email</span>
                    <span class="error font-size-14 color-err display-block" v-if="!$v.email.email">Định dạng email chưa đúng</span>
                    <span class="error font-size-14 color-err display-block" v-if="isEmailInExits">Email này chưa được đăng ký</span>
                </div>
                <!-- <div class="form-group">
                  <h5>Bạn chưa nhận được email? <a href="" style="color:#124ABE;">Gửi lại</a></h5>
                </div> -->
                <div class="text-right form-group form-action">
                  <router-link to="/" class="font-size-15 primary-color" style="margin-right:10px;" exact>Hủy</router-link>
                  <!-- <router-link to="/quen-mat-khau/mat-khau-moi" class="btn btn-primary btn-access" :disabled="$v.email.$invalid || isEmailInExits" exact>Xác nhận</router-link> -->
                  <button class="btn btn-primary btn-access" :disabled="$v.email.$invalid || isEmailInExits">Xác nhận</button>
                </div>
            </form>
          </div>
      </div>
  </div>
</template>

<script>
  import { required, email } from 'vuelidate/lib/validators'
  import { checkExitEmail } from '@/store/auth/api'
  import { checkEmailForgot } from '@/store/auth/api'
  import { APP_CONFIG } from "@/utils/constants";
export default {
  name:"ForgotPassword",
  data () {
    return {
      isEmailInExits: false,
      status: false,
      email: ''
    }
  },
  validations:{
    email:{
      required,
      email,
    },
  },
  methods: {

    checkEmailExit(evt) {
      let self = this;
      let data = evt.target.value;
      self.isEmailExits = false;
      if(data) {
        checkExitEmail({email: data}).then(res => {
          self.isEmailExits = res && res.status === 'failed' ? true : false;
        }).catch(err => console.error(err));
      }
    },
    SubmitEmail(e){
      if (this.$v.$invalid) {
        return;
      }

       checkEmailForgot({ email: this.email, url: window.location.origin +"/quen-mat-khau/mat-khau-moi"})
        .then(res => {
            if (res.status === "success") {
              this.$toast.success("Vui lòng truy cập email của bạn để xác nhận khôi phục mật khẩu");
              this.$router.push({ path: '/' })
            }
        })
    }
  }
}

</script>

<style lang="scss" scoped>
  .wrap-login {height: 100vh;
    min-height: 600px;}
  .login-form{
    background-color: #f3f6fb;
    border-radius: 8px;
    margin: auto;
    padding-bottom: 20px;
    .text-center{
      .mb-5 {
          margin-bottom: 1rem !important;
      }
      h2{
        font-weight: bold;
        color: #40505E;
        padding-top: 35px;
      }
      h5{
        font-size: 14px;
        color: #879AA9;
        text-align: left;
      }
      .input-email{
        border-radius: 20px;
        border: 0;
        height: 30px;
        line-height: 30px;
      }
      label{
        color: #879AA9;
      }
      button{
        font-size: 14px;
      }
      .btn-close{
        background-color: #f3f6fb;
        border-radius: 20px;
        border:1px solid #f3f6fb;
        color: #124ABE;
        height: 30px;
        line-height: 15px;
      }
      .btn-access{
        height: 30px;
        line-height: 15px;
        padding-left: 25px;
        padding-right: 25px;
        border-radius: 20px;
        background-color: #0F3DBA;
      }
      .auth__input{
        border-radius: 20px;
        border: 1px solid #f3f6fb;
        height: 30px;
      }
      ::-webkit-input-placeholder { /* Edge */
          color: #879AA9;
          font-size: 13px;
      }
      .auth__btn{
        height: 30px;
        background-color: #124ABE;
        line-height: 15px;
      }
      .pd-top{
        padding-top: 20px;
        margin-bottom: 0;
        
      }
      .forgot-pwd{
        font-size: 14px;
            color: #879AA9;
        a{
          color: #124ABE;
        }
      }
    }
  }
  .logo-register{
    padding-top: 50px;
    .center{
      padding-top:10px;
      padding-bottom: 50px;
      img {
        display: block;
        margin-left: auto;
        margin-right: auto;
        height: 48px;
      }
    }
  }
 
  @media (max-width: 1440px){
      .col-xl-3.col-lg-4.col-md-5.col-10.login-form {
        max-width: 388px;
      }
    
  }
  @media (max-width: 425px){
      .col-xl-3.col-lg-4.col-md-5.col-10.login-form {
        max-width: 308px;
      }
  }
</style>